module.exports = __webpack_public_path__ + "static/media/AAM.logo.167379a6.svg";